import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

const RowButtons = ({ index, handleAddRow, handleRemoveRow, isLastRow }) => (
    <div>
        {isLastRow && (
            <div>
                <Button onClick={handleAddRow}>+</Button>
                {index !== 0 && <Button onClick={handleRemoveRow}>-</Button>}
            </div>
        )}
    </div>
);

RowButtons.propTypes = {
    index: PropTypes.number,
    handleAddRow: PropTypes.func,
    handleRemoveRow: PropTypes.func,
    isLastRow: PropTypes.bool,
};
RowButtons.defaultProps = {};

export default RowButtons;
